module.exports = __webpack_public_path__ + "img/33.a6892411.jpg";